import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {trackEvent} from '../../tracking/amplitude/TrackingV2';
import {
	UpdateGeneralTimeRegistrationSettingsInput,
	UpdateGeneralTimeRegistrationSettingsMutation,
	UpdateGeneralTimeRegistrationSettingsMutation$rawResponse,
} from './__generated__/UpdateGeneralTimeRegistrationSettingsMutation.graphql';

const mutation = graphql`
	mutation UpdateGeneralTimeRegistrationSettingsMutation($input: UpdateGeneralTimeRegistrationSettingsInput!)
	@raw_response_type {
		updateGeneralTimeRegistrationSettings(input: $input) {
			timeRegistrationSettings {
				granularity
				allowDoneTasks
				allowProjects
				allowInternalTime
				allowBillableSplit
				allowRoles
				allowExceedingEstimate
				allowOutsideProjectDates
				allowOutsideTaskDates
				requireTaskAssignment
				requireNote
				strictMode
			}
		}
	}
`;

function getOptimisticResponse(
	input: UpdateGeneralTimeRegistrationSettingsInput
): UpdateGeneralTimeRegistrationSettingsMutation$rawResponse {
	return {
		updateGeneralTimeRegistrationSettings: {
			timeRegistrationSettings: {
				id: input.id,
				granularity: null,
				allowDoneTasks: input.allowDoneTasks ?? null,
				allowProjects: input.allowProjects ?? null,
				allowInternalTime: input.allowInternalTime ?? null,
				allowBillableSplit: input.allowBillableSplit ?? null,
				allowRoles: input.allowRoles ?? null,
				allowExceedingEstimate: input.allowExceedingEstimate ?? null,
				allowOutsideProjectDates: input.allowOutsideProjectDates ?? null,
				allowOutsideTaskDates: input.allowOutsideTaskDates ?? null,
				requireTaskAssignment: input.requireTaskAssignment ?? null,
				requireNote: input.requireNote ?? null,
				strictMode: input.strictMode ?? null,
			},
		},
	};
}

function commit(
	environment: Environment,
	input: UpdateGeneralTimeRegistrationSettingsInput,
	onSuccess?: (response) => void,
	onError?: (error: Error) => void
): Disposable {
	trackEvent('Time Registration Settings', 'General Settings Updated', input);

	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation<UpdateGeneralTimeRegistrationSettingsMutation>(environment, {
		mutation,
		variables,
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
